<svg width="24" height="24" fill="none" stroke="#000" version="1.1" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
 <path d="M6 18L18 6M6 6L18 18" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/>
</svg>
